import React, { useEffect, useContext, Children } from 'react';

import Box from '@mui/material/Box';
import { alpha } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { DataGrid } from '@mui/x-data-grid';
import CommentIcon from '@mui/icons-material/Comment';
import LinearProgress from '@mui/material/LinearProgress';

import { ContextTraining } from 'context/ContextTraining';

import 'styles/dataGrid.css';
import 'styles/TrainingDetails.css';
import logoDigiForma from 'imgs/logo-digiforma.svg';

const TrainingDetails = () => {

  //context
  const {
    trainingId,
    training,
    getTraining,
    trainingLoading,
    trainingRows
  } = useContext(ContextTraining);


  //effects
  useEffect(() => {
    getTraining();
  }, []);


  //functions
  function CustomNoRowsOverlay() {
    return (<div>Aucunes données</div>);
  }

  const RenderCode = (props) => {
    const { value, row } = props;

    var txt = '';
    if (row.qualityExpectations) txt += '- ' + row.qualityExpectations + '\n\r';
    if (row.qualitySuccessConditions) txt += '- ' + row.qualitySuccessConditions;

    var com = '';
    if (txt.length > 0) {
      com = (<Tooltip
        title={<span style={{ whiteSpace: 'pre-line' }}>{txt}</span>}
        placement="right">
        <CommentIcon fontSize="small" />
      </Tooltip>
      );
    }

    return <>{value}{com}</>;

    /*if (row.inter) {
      return (
        <>
          <div style={{ height: '20px' }}>{value}{com}</div>
          <div style={{ height: '20px' }}>{row.customer}</div>
        </>
      );
    } else {
      return <>{value}{com}</>;
    }*/
  };

  const RenderColor = () => {
    const classColor = training.inter === true ? 'purple' : 'orange'; 
    return <div className={`dataGridRenderCellColor ${classColor}`}></div>;
  };

  const RenderSubsessions = (props) => {
    if (props.row.subsessions.length > 0) {
      const trainingSessions = Array.from(
        new Map(props.row.subsessions.map(item => [item.id_training_session, item])).values()
      );
      return (
        <div className="tableChip">
          <div className="chipCell">
            {Children.toArray(trainingSessions.map((subsession, index) => {
              let color = subsession.id_digiforma_program ? '#00561b' : '#ff8c00';
            
              const displayName = subsession.program_name || subsession.name;
              return (
              <Tooltip
                title={displayName}
                placement="bottom-start"
              >
                <Box component="div" className="chipText"
                  sx={{
                    p: 1,
                    border: 1,
                    color: color,
                    borderColor: alpha(color, 0.6),
                    backgroundColor: alpha(color, 0.1),
                    maxWidth: '100%',
                    flexShrink: 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                  }}
                >
                  {displayName}
                </Box>
              </Tooltip>
              );
            }))}
          </div>
        </div>
      );
    }
    else return (<></>);
  };

  const RenderStatus = (props) => {
    const { value } = props;

    const label = value?.label ? value.label : 'A traiter';
    const className = !value?.color ? 'default' : '';
    const sx = !value?.color ? {} : {
      border: 1,
      color: value.color,
      borderColor: alpha(value.color, 0.6),
      backgroundColor: alpha(value.color, 0.1)
    };

    return (
      <div className="tableChip">
        <div className="chipCell">
          <Box component="div" className={`chipText alone ${className}`} sx={sx}>
            {label}
          </Box>
        </div>
      </div>
    );
  };

  const RenderManager = (props) => {
    var manager = '';
    if (props.row.manager && Object.keys(props.row.manager).length > 0) {
      if (props.row.manager?.lastname) {
        manager += props.row.manager?.lastname + ' ';
      }
      manager += props.row.manager?.firstname;
    }

    return manager;
  };

  const RenderDigiForma = () => {
    return (
      <div className="iconLink">
        <div className="linkButton">
          <a href={`https://app.digiforma.com/training_sessions/${trainingId}`} target="_blank">
            <div className="buttonIcon">
              <img src={logoDigiForma} alt="DigiForma" />
            </div>
          </a>
        </div>
      </div>
    );
  };


  //xGrid
  const columns = [
    { field: 'id', headerName: 'Id', hideable: true },
    { field: 'inter', headerName: 'Inter', hideable: true },
    { field: 'customer', headerName: 'Customer', hideable: true },
    { field: 'qualityExpectations', headerName: 'Expectations', hideable: true },
    { field: 'qualitySuccessConditions', headerName: 'Success Conditions', hideable: true },
    { field: 'code', headerName: 'Code interne', width: 145, renderCell: RenderCode },
    { field: 'startDate', headerName: 'Du', width: 110, type: 'date' },
    { field: 'endDate', headerName: 'Au', width: 110, type: 'date' },
    { field: 'placeInfo', headerName: 'Lieu', flex: 1, width: 170 },
    { field: 'subsessions', headerName: 'Modules', flex: 3, width: 300, renderCell: RenderSubsessions },
    { field: 'manager', headerName: 'Commercial', width: 170, renderCell: RenderManager },
    { field: 'status', headerName: 'Statut', width: 110, align: 'left', renderCell: RenderStatus }
  ];


  return (
    <div className="content-training-details details-block">
      {RenderColor()}
      <div className="details-title">
        {training.name} - du {training.humanReadableStartDate} au {training.humanReadableEndDate}
        <div className="details-digiforma">{RenderDigiForma()}</div>
      </div>
      <DataGrid
        sx={{ height: '100%', width: '100%' }}
        className="dataGrid monoLine"
        components={{
          LoadingOverlay: LinearProgress,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        rows={trainingRows}
        columns={columns}
        loading={trainingLoading}
        hideFooter
        disableColumnMenu
        disableColumnFilter
        disableColumnSorting
        disableSelectionOnClick
        columnVisibilityModel={{
          // Hide columns status and traderName, the other columns will remain visible
          id: false,
          inter: false,
          customer: false,
          qualityExpectations: false,
          qualitySuccessConditions: false,
        }}
        getRowClassName={(params) => {
          return 'dataGridRowClass';
        }}
        getRowHeight={({ model }) => {
          const { subsessions } = model;
          if (subsessions?.length > 0) {
            const trainingSessions = Array.from(
              new Map(subsessions.map(item => [item.id_training_session, item])).values()
            );
            return 30 * trainingSessions?.length;
          }
          return 'auto';
        }}
      />
    </div>
  );
}

export default TrainingDetails;